import React from 'react'
import View from './view'

const EventUpdate = ({ ...props }) => {
    return <View {...props} />
}

export default EventUpdate
